import React from 'react'
import { Icon } from '@iconify/react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import clsx from 'clsx'
const CreationCard = props => {
  const { option, index, onClick, classes } = props
  const [isHovered, setIsHovered] = React.useState(false)
  return (
    <div
      key={option.index}
      onClick={() => onClick(index)}
      className={classes.card}
      onMouseEnter={() => {
        setIsHovered(true)
      }}
      onMouseLeave={() => {
        setIsHovered(false)
      }}
    >
      <div
        className={clsx({
          [classes.iconDiv]: !isHovered,
          [classes.iconDivHover]: isHovered,
        })}
      >
        <Icon
          icon={option.icon}
          className={clsx({
            [classes.icon]: index == 0,
            [classes.iconAi]: index !== 0,
          })}
        />
      </div>
      <Typography
        className={classes.cardTitle}
        dangerouslySetInnerHTML={{ __html: option.cardName }}
      />
    </div>
  )
}

export default withStyles(styles)(CreationCard)
